import { useState } from 'react';
import { CAlert, CAlertHeading, CAlertLink, CButton } from '@coreui/bootstrap-react/src/index';
import CIcon from '@coreui/icons-react';
import { cilBurn, cilCheckCircle, cilInfo, cilWarning } from '@coreui/icons';
import * as React from 'react';
export default {
  useState,
  CAlert,
  CAlertHeading,
  CAlertLink,
  CButton,
  CIcon,
  cilBurn,
  cilCheckCircle,
  cilInfo,
  cilWarning,
  React
};